const countries = [
    {
        "label": "AFGHANISTAN",
        "value": "Afghanistan",
        "description": "",
        "displayOrder": 1,
        "hidden": false
    },
    {
        "label": "ALBANIA",
        "value": "Albania",
        "displayOrder": 3,
        "hidden": false
    },
    {
        "label": "ALGERIA",
        "value": "Algeria",
        "description": "",
        "displayOrder": 4,
        "hidden": false
    },
    {
        "label": "ANDORRA",
        "value": "Andorra",
        "description": "",
        "displayOrder": 5,
        "hidden": false
    },
    {
        "label": "ANGOLA",
        "value": "Angola",
        "description": "",
        "displayOrder": 6,
        "hidden": false
    },
    {
        "label": "ANGUILLA",
        "value": "Anguilla",
        "description": "",
        "displayOrder": 7,
        "hidden": false
    },
    {
        "label": "ANTIGUA AND BARBUDA",
        "value": "Antigua and Barbuda",
        "description": "",
        "displayOrder": 8,
        "hidden": false
    },
    {
        "label": "ARGENTINA",
        "value": "Argentina",
        "description": "",
        "displayOrder": 9,
        "hidden": false
    },
    {
        "label": "ARMENIA",
        "value": "Armenia",
        "displayOrder": 10,
        "hidden": false
    },
    {
        "label": "ARUBA",
        "value": "Aruba",
        "description": "",
        "displayOrder": 11,
        "hidden": false
    },
    {
        "label": "AUSTRALIA",
        "value": "Australia",
        "displayOrder": 12,
        "hidden": false
    },
    {
        "label": "AUSTRIA",
        "value": "Austria",
        "displayOrder": 13,
        "hidden": false
    },
    {
        "label": "AZERBAIJAN",
        "value": "Azerbaijan",
        "displayOrder": 14,
        "hidden": false
    },
    {
        "label": "BAHAMAS",
        "value": "Bahamas",
        "description": "",
        "displayOrder": 15,
        "hidden": false
    },
    {
        "label": "BAHRAIN",
        "value": "Bahrain",
        "description": "",
        "displayOrder": 16,
        "hidden": false
    },
    {
        "label": "BANGLADESH",
        "value": "Bangladesh",
        "description": "",
        "displayOrder": 17,
        "hidden": false
    },
    {
        "label": "BARBADOS",
        "value": "Barbados",
        "description": "",
        "displayOrder": 18,
        "hidden": false
    },
    {
        "label": "BELARUS",
        "value": "Belarus",
        "description": "",
        "displayOrder": 19,
        "hidden": false
    },
    {
        "label": "BELGIUM",
        "value": "Belgium",
        "displayOrder": 20,
        "hidden": false
    },
    {
        "label": "BELIZE",
        "value": "Belize",
        "description": "",
        "displayOrder": 21,
        "hidden": false
    },
    {
        "label": "BENIN",
        "value": "Benin",
        "description": "",
        "displayOrder": 22,
        "hidden": false
    },
    {
        "label": "BERMUDA",
        "value": "Bermuda",
        "description": "",
        "displayOrder": 23,
        "hidden": false
    },
    {
        "label": "BHUTAN",
        "value": "Bhutan",
        "description": "",
        "displayOrder": 24,
        "hidden": false
    },
    {
        "label": "BOLIVIA",
        "value": "Bolivia",
        "description": "",
        "displayOrder": 25,
        "hidden": false
    },
    {
        "label": "BOSNIA AND HERZEGOVINA",
        "value": "Bosnia and Herzegovina",
        "displayOrder": 26,
        "hidden": false
    },
    {
        "label": "BOTSWANA",
        "value": "Botswana",
        "description": "",
        "displayOrder": 27,
        "hidden": false
    },
    {
        "label": "BRAZIL",
        "value": "Brazil",
        "description": "",
        "displayOrder": 28,
        "hidden": false
    },
    {
        "label": "BRITISH VIRGIN ISLANDS",
        "value": "British Virgin Islands",
        "description": "",
        "displayOrder": 29,
        "hidden": false
    },
    {
        "label": "BRUNEI DARUSSALAM",
        "value": "Brunei Darussalam",
        "description": "",
        "displayOrder": 30,
        "hidden": false
    },
    {
        "label": "BULGARIA",
        "value": "Bulgaria",
        "displayOrder": 31,
        "hidden": false
    },
    {
        "label": "BURKINA FASO",
        "value": "Burkina Faso",
        "description": "",
        "displayOrder": 32,
        "hidden": false
    },
    {
        "label": "BURUNDI",
        "value": "Burundi",
        "description": "",
        "displayOrder": 33,
        "hidden": false
    },
    {
        "label": "CAMBODIA",
        "value": "Cambodia",
        "description": "",
        "displayOrder": 34,
        "hidden": false
    },
    {
        "label": "CAMEROON",
        "value": "Cameroon",
        "description": "",
        "displayOrder": 35,
        "hidden": false
    },
    {
        "label": "CANADA",
        "value": "Canada",
        "displayOrder": 36,
        "hidden": false
    },
    {
        "label": "CAPE VERDE",
        "value": "Cape Verde",
        "description": "",
        "displayOrder": 37,
        "hidden": false
    },
    {
        "label": "CAYMAN ISLANDS",
        "value": "Cayman Islands",
        "description": "",
        "displayOrder": 38,
        "hidden": false
    },
    {
        "label": "CENTRAL AFRICAN REPUBLIC",
        "value": "Central African Republic",
        "description": "",
        "displayOrder": 39,
        "hidden": false
    },
    {
        "label": "CHAD",
        "value": "Chad",
        "description": "",
        "displayOrder": 40,
        "hidden": false
    },
    {
        "label": "CHILE",
        "value": "Chile",
        "description": "",
        "displayOrder": 41,
        "hidden": false
    },
    {
        "label": "CHINA",
        "value": "China",
        "displayOrder": 42,
        "hidden": false
    },
    {
        "label": "COLOMBIA",
        "value": "Colombia",
        "description": "",
        "displayOrder": 43,
        "hidden": false
    },
    {
        "label": "COMOROS",
        "value": "Comoros",
        "description": "",
        "displayOrder": 44,
        "hidden": false
    },
    {
        "label": "CONGO",
        "value": "Congo",
        "description": "",
        "displayOrder": 45,
        "hidden": false
    },
    {
        "label": "COOK ISLANDS (NZ)",
        "value": "Cook Islands (NZ)",
        "description": "",
        "displayOrder": 46,
        "hidden": false
    },
    {
        "label": "COSTA RICA",
        "value": "Costa Rica",
        "description": "",
        "displayOrder": 47,
        "hidden": false
    },
    {
        "label": "CROATIA",
        "value": "Croatia",
        "displayOrder": 48,
        "hidden": false
    },
    {
        "label": "CUBA",
        "value": "Cuba",
        "description": "",
        "displayOrder": 49,
        "hidden": false
    },
    {
        "label": "CURAÇAO",
        "value": "Curaçao",
        "description": "",
        "displayOrder": 50,
        "hidden": false
    },
    {
        "label": "CYPRUS",
        "value": "Cyprus",
        "displayOrder": 51,
        "hidden": false
    },
    {
        "label": "CZECH REPUBLIC",
        "value": "Czech Republic",
        "displayOrder": 52,
        "hidden": false
    },
    {
        "label": "CÔTE D'IVOIRE",
        "value": "Côte d'Ivoire",
        "description": "",
        "displayOrder": 53,
        "hidden": false
    },
    {
        "label": "DEMOCRATIC REPUBLIC OF THE CONGO",
        "value": "Democratic Republic of the Congo",
        "description": "",
        "displayOrder": 54,
        "hidden": false
    },
    {
        "label": "DENMARK",
        "value": "Denmark",
        "displayOrder": 55,
        "hidden": false
    },
    {
        "label": "DJIBOUTI",
        "value": "Djibouti",
        "description": "",
        "displayOrder": 56,
        "hidden": false
    },
    {
        "label": "DOMINICA",
        "value": "Dominica",
        "description": "",
        "displayOrder": 57,
        "hidden": false
    },
    {
        "label": "DOMINICAN REPUBLIC",
        "value": "Dominican Republic",
        "description": "",
        "displayOrder": 58,
        "hidden": false
    },
    {
        "label": "ECUADOR",
        "value": "Ecuador",
        "description": "",
        "displayOrder": 59,
        "hidden": false
    },
    {
        "label": "EGYPT",
        "value": "Egypt",
        "description": "",
        "displayOrder": 60,
        "hidden": false
    },
    {
        "label": "EL SALVADOR",
        "value": "El Salvador",
        "description": "",
        "displayOrder": 61,
        "hidden": false
    },
    {
        "label": "EQUATORIAL GUINEA",
        "value": "Equatorial Guinea",
        "description": "",
        "displayOrder": 62,
        "hidden": false
    },
    {
        "label": "ERITREA",
        "value": "Eritrea",
        "description": "",
        "displayOrder": 63,
        "hidden": false
    },
    {
        "label": "ESTONIA",
        "value": "Estonia",
        "displayOrder": 64,
        "hidden": false
    },
    {
        "label": "ESWATINI",
        "value": "Eswatini",
        "description": "",
        "displayOrder": 65,
        "hidden": false
    },
    {
        "label": "ETHIOPIA",
        "value": "Ethiopia",
        "description": "",
        "displayOrder": 66,
        "hidden": false
    },
    {
        "label": "FALKLAND ISLANDS (MALVINAS)",
        "value": "Falkland Islands (Malvinas)",
        "description": "",
        "displayOrder": 67,
        "hidden": false
    },
    {
        "label": "FAR EAST",
        "value": "Far East",
        "description": "",
        "displayOrder": 68,
        "hidden": false
    },
    {
        "label": "FAROE ISLANDS",
        "value": "Faroe Islands",
        "description": "",
        "displayOrder": 69,
        "hidden": false
    },
    {
        "label": "FEDERATED STATES OF MICRONESIA",
        "value": "Federated States of Micronesia",
        "description": "",
        "displayOrder": 70,
        "hidden": false
    },
    {
        "label": "FIJI",
        "value": "Fiji",
        "description": "",
        "displayOrder": 71,
        "hidden": false
    },
    {
        "label": "FINLAND",
        "value": "Finland",
        "displayOrder": 72,
        "hidden": false
    },
    {
        "label": "FRANCE",
        "value": "France",
        "displayOrder": 73,
        "hidden": false
    },
    {
        "label": "FRENCH POLYNESIA",
        "value": "French Polynesia",
        "displayOrder": 74,
        "hidden": false
    },
    {
        "label": "FRENCH SOUTHERN TERRITORIES",
        "value": "French Southern Territories",
        "description": "",
        "displayOrder": 75,
        "hidden": false
    },
    {
        "label": "GABON",
        "value": "Gabon",
        "description": "",
        "displayOrder": 76,
        "hidden": false
    },
    {
        "label": "GAMBIA",
        "value": "Gambia",
        "description": "",
        "displayOrder": 77,
        "hidden": false
    },
    {
        "label": "GEORGIA",
        "value": "Georgia",
        "displayOrder": 78,
        "hidden": false
    },
    {
        "label": "GERMANY",
        "value": "Germany",
        "displayOrder": 79,
        "hidden": false
    },
    {
        "label": "GHANA",
        "value": "Ghana",
        "description": "",
        "displayOrder": 80,
        "hidden": false
    },
    {
        "label": "GIBRALTAR",
        "value": "Gibraltar",
        "description": "",
        "displayOrder": 81,
        "hidden": false
    },
    {
        "label": "GREECE",
        "value": "Greece",
        "displayOrder": 82,
        "hidden": false
    },
    {
        "label": "GREENLAND",
        "value": "Greenland",
        "description": "",
        "displayOrder": 83,
        "hidden": false
    },
    {
        "label": "GRENADA",
        "value": "Grenada",
        "description": "",
        "displayOrder": 84,
        "hidden": false
    },
    {
        "label": "GUATEMALA",
        "value": "Guatemala",
        "description": "",
        "displayOrder": 85,
        "hidden": false
    },
    {
        "label": "GUERNSEY",
        "value": "Guernsey",
        "description": "",
        "displayOrder": 86,
        "hidden": false
    },
    {
        "label": "GUINEA",
        "value": "Guinea",
        "description": "",
        "displayOrder": 87,
        "hidden": false
    },
    {
        "label": "GUINEA-BISSAU",
        "value": "Guinea-Bissau",
        "description": "",
        "displayOrder": 88,
        "hidden": false
    },
    {
        "label": "GUYANA",
        "value": "Guyana",
        "description": "",
        "displayOrder": 89,
        "hidden": false
    },
    {
        "label": "HAITI",
        "value": "Haiti",
        "description": "",
        "displayOrder": 90,
        "hidden": false
    },
    {
        "label": "HONDURAS",
        "value": "Honduras",
        "description": "",
        "displayOrder": 91,
        "hidden": false
    },
    {
        "label": "HUNGARY",
        "value": "Hungary",
        "displayOrder": 92,
        "hidden": false
    },
    {
        "label": "ICELAND",
        "value": "Iceland",
        "description": "",
        "displayOrder": 93,
        "hidden": false
    },
    {
        "label": "INDIA",
        "value": "India",
        "displayOrder": 94,
        "hidden": false
    },
    {
        "label": "INDONESIA",
        "value": "Indonesia",
        "displayOrder": 95,
        "hidden": false
    },
    {
        "label": "IRAN",
        "value": "Iran",
        "description": "",
        "displayOrder": 96,
        "hidden": false
    },
    {
        "label": "IRAQ",
        "value": "Iraq",
        "description": "",
        "displayOrder": 97,
        "hidden": false
    },
    {
        "label": "IRELAND",
        "value": "Ireland",
        "displayOrder": 98,
        "hidden": false
    },
    {
        "label": "ISLE OF MAN",
        "value": "Isle of Man",
        "description": "",
        "displayOrder": 99,
        "hidden": false
    },
    {
        "label": "ISRAEL",
        "value": "Israel",
        "displayOrder": 100,
        "hidden": false
    },
    {
        "label": "ITALIA",
        "value": "Italia",
        "displayOrder": 101,
        "hidden": false
    },
    {
        "label": "JAMAICA",
        "value": "Jamaica",
        "description": "",
        "displayOrder": 102,
        "hidden": false
    },
    {
        "label": "JAPAN",
        "value": "Japan",
        "description": "",
        "displayOrder": 103,
        "hidden": false
    },
    {
        "label": "JERSEY",
        "value": "Jersey",
        "description": "",
        "displayOrder": 104,
        "hidden": false
    },
    {
        "label": "JORDAN",
        "value": "Jordan",
        "description": "",
        "displayOrder": 105,
        "hidden": false
    },
    {
        "label": "KAZAKHSTAN",
        "value": "Kazakhstan",
        "displayOrder": 106,
        "hidden": false
    },
    {
        "label": "KENYA",
        "value": "Kenya",
        "description": "",
        "displayOrder": 107,
        "hidden": false
    },
    {
        "label": "KIRIBATI",
        "value": "Kiribati",
        "description": "",
        "displayOrder": 108,
        "hidden": false
    },
    {
        "label": "KOSOVO",
        "value": "Kosovo",
        "displayOrder": 109,
        "hidden": false
    },
    {
        "label": "KUWAIT",
        "value": "Kuwait",
        "displayOrder": 110,
        "hidden": false
    },
    {
        "label": "KYRGYZSTAN",
        "value": "Kyrgyzstan",
        "displayOrder": 111,
        "hidden": false
    },
    {
        "label": "LAOS",
        "value": "Laos",
        "description": "",
        "displayOrder": 112,
        "hidden": false
    },
    {
        "label": "LATVIA",
        "value": "Latvia",
        "displayOrder": 113,
        "hidden": false
    },
    {
        "label": "LEBANON",
        "value": "Lebanon",
        "displayOrder": 114,
        "hidden": false
    },
    {
        "label": "LESOTHO",
        "value": "Lesotho",
        "description": "",
        "displayOrder": 115,
        "hidden": false
    },
    {
        "label": "LIBERIA",
        "value": "Liberia",
        "description": "",
        "displayOrder": 116,
        "hidden": false
    },
    {
        "label": "LIBYA",
        "value": "Libya",
        "description": "",
        "displayOrder": 117,
        "hidden": false
    },
    {
        "label": "LIECHTENSTEIN",
        "value": "Liechtenstein",
        "description": "",
        "displayOrder": 118,
        "hidden": false
    },
    {
        "label": "LITHUANIA",
        "value": "Lithuania",
        "displayOrder": 119,
        "hidden": false
    },
    {
        "label": "LUXEMBOURG",
        "value": "Luxembourg",
        "displayOrder": 120,
        "hidden": false
    },
    {
        "label": "MACEDONIA",
        "value": "North Macedonia",
        "displayOrder": 121,
        "hidden": false
    },
    {
        "label": "MADAGASCAR",
        "value": "Madagascar",
        "description": "",
        "displayOrder": 122,
        "hidden": false
    },
    {
        "label": "MALAWI",
        "value": "Malawi",
        "description": "",
        "displayOrder": 123,
        "hidden": false
    },
    {
        "label": "MALAYSIA",
        "value": "Malaysia",
        "description": "",
        "displayOrder": 124,
        "hidden": false
    },
    {
        "label": "MALDIVES",
        "value": "Maldives",
        "description": "",
        "displayOrder": 125,
        "hidden": false
    },
    {
        "label": "MALI",
        "value": "Mali",
        "description": "",
        "displayOrder": 126,
        "hidden": false
    },
    {
        "label": "MALTA",
        "value": "Malta",
        "displayOrder": 127,
        "hidden": false
    },
    {
        "label": "MARSHALL ISLANDS",
        "value": "Marshall Islands",
        "description": "",
        "displayOrder": 128,
        "hidden": false
    },
    {
        "label": "MAURITANIA",
        "value": "Mauritania",
        "description": "",
        "displayOrder": 129,
        "hidden": false
    },
    {
        "label": "MAURITIUS",
        "value": "Mauritius",
        "description": "",
        "displayOrder": 130,
        "hidden": false
    },
    {
        "label": "MEXICO",
        "value": "Mexico",
        "description": "",
        "displayOrder": 131,
        "hidden": false
    },
    {
        "label": "MOLDOVA",
        "value": "Moldova",
        "displayOrder": 132,
        "hidden": false
    },
    {
        "label": "MONACO",
        "value": "Monaco",
        "description": "",
        "displayOrder": 133,
        "hidden": false
    },
    {
        "label": "MONGOLIA",
        "value": "Mongolia",
        "description": "",
        "displayOrder": 134,
        "hidden": false
    },
    {
        "label": "MONTENEGRO",
        "value": "Montenegro",
        "displayOrder": 135,
        "hidden": false
    },
    {
        "label": "MONTSERRAT",
        "value": "Montserrat",
        "description": "",
        "displayOrder": 136,
        "hidden": false
    },
    {
        "label": "MOROCCO",
        "value": "Morocco",
        "description": "",
        "displayOrder": 137,
        "hidden": false
    },
    {
        "label": "MOZAMBIQUE",
        "value": "Mozambique",
        "description": "",
        "displayOrder": 138,
        "hidden": false
    },
    {
        "label": "MYANMAR/BURMA",
        "value": "Myanmar/Burma",
        "description": "",
        "displayOrder": 139,
        "hidden": false
    },
    {
        "label": "NAMIBIA",
        "value": "Namibia",
        "description": "",
        "displayOrder": 140,
        "hidden": false
    },
    {
        "label": "NAURU",
        "value": "Nauru",
        "description": "",
        "displayOrder": 141,
        "hidden": false
    },
    {
        "label": "NEPAL",
        "value": "Nepal",
        "description": "",
        "displayOrder": 142,
        "hidden": false
    },
    {
        "label": "NETHERLANDS",
        "value": "Netherlands",
        "displayOrder": 143,
        "hidden": false
    },
    {
        "label": "NEW CALEDONIA",
        "value": "New Caledonia",
        "displayOrder": 144,
        "hidden": false
    },
    {
        "label": "NEW ZEALAND",
        "value": "New Zealand",
        "description": "",
        "displayOrder": 145,
        "hidden": false
    },
    {
        "label": "NICARAGUA",
        "value": "Nicaragua",
        "description": "",
        "displayOrder": 146,
        "hidden": false
    },
    {
        "label": "NIGER",
        "value": "Niger",
        "description": "",
        "displayOrder": 147,
        "hidden": false
    },
    {
        "label": "NIGERIA",
        "value": "Nigeria",
        "description": "",
        "displayOrder": 148,
        "hidden": false
    },
    {
        "label": "NORTH KOREA",
        "value": "North Korea",
        "description": "",
        "displayOrder": 149,
        "hidden": false
    },
    {
        "label": "NORWAY",
        "value": "Norway",
        "displayOrder": 150,
        "hidden": false
    },
    {
        "label": "OMAN",
        "value": "Oman",
        "description": "",
        "displayOrder": 151,
        "hidden": false
    },
    {
        "label": "PAKISTAN",
        "value": "Pakistan",
        "description": "",
        "displayOrder": 152,
        "hidden": false
    },
    {
        "label": "PALAU",
        "value": "Palau",
        "description": "",
        "displayOrder": 153,
        "hidden": false
    },
    {
        "label": "PALESTINE",
        "value": "Palestine",
        "description": "",
        "displayOrder": 154,
        "hidden": false
    },
    {
        "label": "PANAMA",
        "value": "Panama",
        "description": "",
        "displayOrder": 155,
        "hidden": false
    },
    {
        "label": "PAPUA NEW GUINEA",
        "value": "Papua New Guinea",
        "description": "",
        "displayOrder": 156,
        "hidden": false
    },
    {
        "label": "PARAGUAY",
        "value": "Paraguay",
        "description": "",
        "displayOrder": 157,
        "hidden": false
    },
    {
        "label": "PERU",
        "value": "Peru",
        "description": "",
        "displayOrder": 158,
        "hidden": false
    },
    {
        "label": "PHILIPPINES",
        "value": "Philippines",
        "displayOrder": 159,
        "hidden": false
    },
    {
        "label": "PITCAIRN",
        "value": "Pitcairn",
        "description": "",
        "displayOrder": 160,
        "hidden": false
    },
    {
        "label": "POLAND",
        "value": "Poland",
        "displayOrder": 161,
        "hidden": false
    },
    {
        "label": "PORTUGAL",
        "value": "Portugal",
        "displayOrder": 162,
        "hidden": false
    },
    {
        "label": "PUERTO RICO",
        "value": "Puerto Rico",
        "description": "",
        "displayOrder": 163,
        "hidden": false
    },
    {
        "label": "QATAR",
        "value": "Qatar",
        "description": "",
        "displayOrder": 164,
        "hidden": false
    },
    {
        "label": "ROMANIA",
        "value": "Romania",
        "displayOrder": 165,
        "hidden": false
    },
    {
        "label": "RUSSIAN FEDERATION",
        "value": "Russian Federation",
        "displayOrder": 166,
        "hidden": false
    },
    {
        "label": "RWANDA",
        "value": "Rwanda",
        "description": "",
        "displayOrder": 167,
        "hidden": false
    },
    {
        "label": "SAINT BARTHELEMY",
        "value": "Saint Barthelemy",
        "description": "",
        "displayOrder": 168,
        "hidden": false
    },
    {
        "label": "SAINT HELENA",
        "value": "Saint Helena",
        "description": "",
        "displayOrder": 169,
        "hidden": false
    },
    {
        "label": "SAINT KITTS AND NEVIS",
        "value": "Saint Kitts and Nevis",
        "description": "",
        "displayOrder": 170,
        "hidden": false
    },
    {
        "label": "SAINT LUCIA",
        "value": "Saint Lucia",
        "description": "",
        "displayOrder": 171,
        "hidden": false
    },
    {
        "label": "SAINT MARTIN (FR)",
        "value": "Saint Martin (FR)",
        "description": "",
        "displayOrder": 172,
        "hidden": false
    },
    {
        "label": "SAINT PIERRE AND MIQUELON",
        "value": "Saint Pierre and Miquelon",
        "description": "",
        "displayOrder": 173,
        "hidden": false
    },
    {
        "label": "SAINT VINCENT AND THE GRENADINES",
        "value": "Saint Vincent and the Grenadines",
        "description": "",
        "displayOrder": 174,
        "hidden": false
    },
    {
        "label": "SAMOA",
        "value": "Samoa",
        "description": "",
        "displayOrder": 175,
        "hidden": false
    },
    {
        "label": "SAN MARINO",
        "value": "San Marino",
        "description": "",
        "displayOrder": 176,
        "hidden": false
    },
    {
        "label": "SAN MARINO (RSM)",
        "value": "San Marino (RSM)",
        "description": "",
        "displayOrder": 177,
        "hidden": false
    },
    {
        "label": "SAO TOME AND PRINCIPE",
        "value": "Sao Tome and Principe",
        "description": "",
        "displayOrder": 178,
        "hidden": false
    },
    {
        "label": "SARK",
        "value": "Sark",
        "description": "",
        "displayOrder": 179,
        "hidden": false
    },
    {
        "label": "SAUDI ARABIA",
        "value": "Saudi Arabia",
        "displayOrder": 180,
        "hidden": false
    },
    {
        "label": "SENEGAL",
        "value": "Senegal",
        "description": "",
        "displayOrder": 181,
        "hidden": false
    },
    {
        "label": "SERBIA",
        "value": "Serbia",
        "displayOrder": 182,
        "hidden": false
    },
    {
        "label": "SEYCHELLES",
        "value": "Seychelles",
        "displayOrder": 183,
        "hidden": false
    },
    {
        "label": "SIERRA LEONE",
        "value": "Sierra Leone",
        "description": "",
        "displayOrder": 184,
        "hidden": false
    },
    {
        "label": "SINGAPORE",
        "value": "Singapore",
        "displayOrder": 185,
        "hidden": false
    },
    {
        "label": "SLOVAKIA",
        "value": "Slovakia",
        "displayOrder": 186,
        "hidden": false
    },
    {
        "label": "SLOVENIA",
        "value": "Slovenia",
        "displayOrder": 187,
        "hidden": false
    },
    {
        "label": "SOLOMON ISLANDS",
        "value": "Solomon Islands",
        "description": "",
        "displayOrder": 188,
        "hidden": false
    },
    {
        "label": "SOMALIA",
        "value": "Somalia",
        "description": "",
        "displayOrder": 189,
        "hidden": false
    },
    {
        "label": "SOUTH AFRICA",
        "value": "South Africa",
        "description": "",
        "displayOrder": 190,
        "hidden": false
    },
    {
        "label": "SOUTH KOREA",
        "value": "South Korea",
        "description": "",
        "displayOrder": 191,
        "hidden": false
    },
    {
        "label": "SOUTH SUDAN",
        "value": "South Sudan",
        "description": "",
        "displayOrder": 192,
        "hidden": false
    },
    {
        "label": "SPAIN",
        "value": "Spain",
        "displayOrder": 193,
        "hidden": false
    },
    {
        "label": "SRI LANKA",
        "value": "Sri Lanka",
        "description": "",
        "displayOrder": 194,
        "hidden": false
    },
    {
        "label": "ST MAARTEN (NL)",
        "value": "St Maarten (NL)",
        "description": "",
        "displayOrder": 195,
        "hidden": false
    },
    {
        "label": "SUDAN",
        "value": "Sudan",
        "description": "",
        "displayOrder": 196,
        "hidden": false
    },
    {
        "label": "SURINAME",
        "value": "Suriname",
        "description": "",
        "displayOrder": 197,
        "hidden": false
    },
    {
        "label": "SWEDEN",
        "value": "Sweden",
        "description": "",
        "displayOrder": 198,
        "hidden": false
    },
    {
        "label": "SWITZERLAND",
        "value": "Switzerland",
        "displayOrder": 199,
        "hidden": false
    },
    {
        "label": "SYRIA",
        "value": "Syria",
        "description": "",
        "displayOrder": 200,
        "hidden": false
    },
    {
        "label": "TAIWAN",
        "value": "Taiwan",
        "description": "",
        "displayOrder": 201,
        "hidden": false
    },
    {
        "label": "TAJIKISTAN",
        "value": "Tajikistan",
        "description": "",
        "displayOrder": 202,
        "hidden": false
    },
    {
        "label": "TANZANIA",
        "value": "Tanzania",
        "description": "",
        "displayOrder": 203,
        "hidden": false
    },
    {
        "label": "THAILAND",
        "value": "Thailand",
        "description": "",
        "displayOrder": 204,
        "hidden": false
    },
    {
        "label": "TIMOR LESTE",
        "value": "Timor Leste",
        "description": "",
        "displayOrder": 205,
        "hidden": false
    },
    {
        "label": "TOGO",
        "value": "Togo",
        "description": "",
        "displayOrder": 206,
        "hidden": false
    },
    {
        "label": "TONGA",
        "value": "Tonga",
        "description": "",
        "displayOrder": 207,
        "hidden": false
    },
    {
        "label": "TRINIDAD AND TOBAGO",
        "value": "Trinidad and Tobago",
        "description": "",
        "displayOrder": 208,
        "hidden": false
    },
    {
        "label": "TUNISIA",
        "value": "Tunisia",
        "description": "",
        "displayOrder": 209,
        "hidden": false
    },
    {
        "label": "TURKEY",
        "value": "Turkey",
        "displayOrder": 210,
        "hidden": false
    },
    {
        "label": "TURKMENISTAN",
        "value": "Turkmenistan",
        "description": "",
        "displayOrder": 211,
        "hidden": false
    },
    {
        "label": "TURKS AND CAICOS ISLANDS",
        "value": "Turks and Caicos Islands",
        "description": "",
        "displayOrder": 212,
        "hidden": false
    },
    {
        "label": "TUVALU",
        "value": "Tuvalu",
        "description": "",
        "displayOrder": 213,
        "hidden": false
    },
    {
        "label": "UGANDA",
        "value": "Uganda",
        "description": "",
        "displayOrder": 214,
        "hidden": false
    },
    {
        "label": "UKRAINE",
        "value": "Ukraine",
        "displayOrder": 215,
        "hidden": false
    },
    {
        "label": "UNITED ARAB EMIRATES",
        "value": "United Arab Emirates",
        "displayOrder": 216,
        "hidden": false
    },
    {
        "label": "UNITED KINGDOM",
        "value": "United Kingdom",
        "displayOrder": 217,
        "hidden": false
    },
    {
        "label": "UNITED STATES OF AMERICA",
        "value": "United States of America",
        "displayOrder": 218,
        "hidden": false
    },
    {
        "label": "URUGUAY",
        "value": "Uruguay",
        "description": "",
        "displayOrder": 219,
        "hidden": false
    },
    {
        "label": "UZBEKISTAN",
        "value": "Uzbekistan",
        "displayOrder": 220,
        "hidden": false
    },
    {
        "label": "VANUATU",
        "value": "Vanuatu",
        "description": "",
        "displayOrder": 221,
        "hidden": false
    },
    {
        "label": "VATICAN CITY STATE",
        "value": "Vatican City State",
        "description": "",
        "displayOrder": 222,
        "hidden": false
    },
    {
        "label": "VENEZUELA",
        "value": "Venezuela",
        "description": "",
        "displayOrder": 223,
        "hidden": false
    },
    {
        "label": "VIETNAM",
        "value": "Vietnam",
        "description": "",
        "displayOrder": 224,
        "hidden": false
    },
    {
        "label": "WALLIS AND FUTUNA ISLANDS",
        "value": "Wallis and Futuna Islands",
        "description": "",
        "displayOrder": 225,
        "hidden": false
    },
    {
        "label": "WESTERN SAHARA",
        "value": "Western Sahara",
        "description": "",
        "displayOrder": 226,
        "hidden": false
    },
    {
        "label": "YEMEN",
        "value": "Yemen",
        "description": "",
        "displayOrder": 227,
        "hidden": false
    },
    {
        "label": "ZAMBIA",
        "value": "Zambia",
        "description": "",
        "displayOrder": 228,
        "hidden": false
    },
    {
        "label": "ZIMBABWE",
        "value": "Zimbabwe",
        "description": "",
        "displayOrder": 229,
        "hidden": false
    }
]

// ISO 3166-1 alpha-2 codes, aligned with the countries array above.
// `null` is used when the list entry has no standalone official ISO code.
const hsCountryRegionCodes = [
    "AF", "AL", "DZ", "AD", "AO", "AI", "AG", "AR", "AM", "AW", "AU", "AT", "AZ", "BS", "BH", "BD", "BB", "BY", "BE", "BZ",
    "BJ", "BM", "BT", "BO", "BA", "BW", "BR", "VG", "BN", "BG", "BF", "BI", "KH", "CM", "CA", "CV", "KY", "CF", "TD", "CL",
    "CN", "CO", "KM", "CG", "CK", "CR", "HR", "CU", "CW", "CY", "CZ", "CI", "CD", "DK", "DJ", "DM", "DO", "EC", "EG", "SV",
    "GQ", "ER", "EE", "SZ", "ET", "FK", null, "FO", "FM", "FJ", "FI", "FR", "PF", "TF", "GA", "GM", "GE", "DE", "GH", "GI",
    "GR", "GL", "GD", "GT", "GG", "GN", "GW", "GY", "HT", "HN", "HU", "IS", "IN", "ID", "IR", "IQ", "IE", "IM", "IL", "IT",
    "JM", "JP", "JE", "JO", "KZ", "KE", "KI", null, "KW", "KG", "LA", "LV", "LB", "LS", "LR", "LY", "LI", "LT", "LU", "MK",
    "MG", "MW", "MY", "MV", "ML", "MT", "MH", "MR", "MU", "MX", "MD", "MC", "MN", "ME", "MS", "MA", "MZ", "MM", "NA", "NR",
    "NP", "NL", "NC", "NZ", "NI", "NE", "NG", "KP", "NO", "OM", "PK", "PW", "PS", "PA", "PG", "PY", "PE", "PH", "PN", "PL",
    "PT", "PR", "QA", "RO", "RU", "RW", "BL", "SH", "KN", "LC", "MF", "PM", "VC", "WS", "SM", "SM", "ST", null, "SA", "SN",
    "RS", "SC", "SL", "SG", "SK", "SI", "SB", "SO", "ZA", "KR", "SS", "ES", "LK", "SX", "SD", "SR", "SE", "CH", "SY", "TW",
    "TJ", "TZ", "TH", "TL", "TG", "TO", "TT", "TN", "TR", "TM", "TC", "TV", "UG", "UA", "AE", "GB", "US", "UY", "UZ", "VU",
    "VA", "VE", "VN", "WF", "EH", "YE", "ZM", "ZW"
]

export default countries.map((country, index) => ({
    ...country,
    hs_country_region_code: hsCountryRegionCodes[index]
}))
